import { useTranslation } from 'react-i18next';

const useT = () => {
  const { t: tFunc } = useTranslation();

  return {
    t: (str: string, values?: Record<string, unknown>) =>
      tFunc(str, values) as string
  };
};

export default useT;
